import {
  SET_ICP_PROGRESS,
  SET_CAMPAIGN_PROGRESS,
  CLEAR_PROGRESS,
  CLEAR_ALL_PROGRESS,
} from "../constants/firebaseProgressConstants";

export const setIcpProgress = (campaignId, data) => ({
  type: SET_ICP_PROGRESS,
  payload: { campaignId, data },
});

export const setCampaignProgress = (campaignId, data) => ({
  type: SET_CAMPAIGN_PROGRESS,
  payload: { campaignId, data },
});

export const clearProgress = (campaignId) => ({
  type: CLEAR_PROGRESS,
  payload: { campaignId },
});

export const clearAllProgress = () => ({
  type: CLEAR_ALL_PROGRESS,
});
